module.exports = __webpack_public_path__ + "img/7ea8e55.png";